module.exports = __webpack_public_path__ + "static/media/a_vu.b026434b.png";